import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { TranslatedCopy } from '../../intl/TranslatedCopy';
import StatusToolTip from './StatusToolTip';
import { Currency, Icon, P } from '../../components/';

import { RETURN_CODE_UNSUBMITTED } from '../../shop/constants';

// TODO: handleDeleteClick
const ReturnStatusCard = ({ returnData, handleClick, handleDeleteClick }) => {
  if (!returnData) return null;
  // --
  const {
    id,
    currencyCode,
    returnAuthorization,
    departmentName,
    referenceId,
    creditType,
    creditedAmount,
    createdBy,
    dateSubmitted,
    expirationDate,
    status
  } = returnData;
  const deleteText = new TranslatedCopy({ id: 'returnStatus.delete' }).toString();
  const handleCardClick = e => handleClick(returnData, e);
  return (
    <div className='orderStatus__card bg-white pt5-sm pb4-sm prl4-sm border-bottom' onClick={handleCardClick}>
      <div className='mb4-sm'>{returnAuthorization}</div>
      <div className='text-color-secondary'>
        <P>
          <TranslatedCopy id='global.department' />
          {': '}
          {departmentName}
        </P>
        <P>
          <TranslatedCopy id='returnStatus.returnReference' />
          {': '}
          {referenceId}
        </P>
        <P>
          <TranslatedCopy id='returnStatus.creditType' />
          {': '}
          {creditType ? (
            <TranslatedCopy id={`returnStatus.creditType.${creditType.split('-').join('.').toLowerCase()}`} />
          ) : null}
        </P>
        <P>
          <TranslatedCopy id='orderreturns.returnAmount' />
          {': '}
          <Currency value={creditedAmount} type={currencyCode} />
        </P>
        <P>
          <TranslatedCopy id='global.submittedBy' />
          {': '}
          {createdBy}
        </P>
        <P>
          <TranslatedCopy id='orderstatus.orderSubmittedDate' />
          {': '}
          <FormattedDate value={dateSubmitted} timeZone='utc' />
        </P>
        {expirationDate && (
          <P>
            <TranslatedCopy id='returnStatus.dateExpires' />
            {': '}
            <FormattedDate value={expirationDate} timeZone='utc' />
          </P>
        )}
        {status && (
          <P className='flex-container row space-between' style={{ alignItems: 'center' }}>
            <span>
              <TranslatedCopy id='returnStatus.title' />
              {': '}
              <TranslatedCopy id={`returnStatus.returnStatus.${status.split(' ').join('').toLowerCase()}`} />
            </span>
            <span>
              <StatusToolTip />
            </span>
          </P>
        )}
        {status === RETURN_CODE_UNSUBMITTED && (
          <button
            type='button'
            className='returnStatus__tooltip p0-sm'
            onClick={e => handleDeleteClick(id, e)}
            title={deleteText}
            aria-label={deleteText}
          >
            <Icon name='trash' />
          </button>
        )}
      </div>
    </div>
  );
};

ReturnStatusCard.defaultProps = {
  returnData: null
};

ReturnStatusCard.propTypes = {
  returnData: PropTypes.any,
  handleClick: PropTypes.func.isRequired,
  handleDeleteClick: PropTypes.func.isRequired
};

export default ReturnStatusCard;
